import authService from '@/services/authService';
import router from '@/router';

const state = {
  token: localStorage.getItem('token') || null,
  user: JSON.parse(localStorage.getItem('user')) || null,
  userPermissions: JSON.parse(localStorage.getItem('userPermissions')) || [],
  userRole: localStorage.getItem('userRole') || null,
  error: null
};

const getters = {
  isAuthenticated: state => !!state.token,
  currentUser: state => state.user,
  userPermissions: state => state.userPermissions,
  userRole: state => state.userRole,
  hasPermission: state => permission => {
    if (state.userRole === 'admin') {
      return true;
    }
    
    return state.userPermissions.includes(permission);
  },
  userRoles: state => {
    if (!state.user) {
      console.log('No current user found');
      return [];
    }
    
    console.log('Current user in getter:', state.user);
    
    if (state.user.roles) {
      if (Array.isArray(state.user.roles) && state.user.roles.length > 0 && typeof state.user.roles[0] === 'object') {
        return state.user.roles.map(role => role.name);
      }
      else if (Array.isArray(state.user.roles)) {
        return state.user.roles;
      }
    }
    
    if (typeof state.user.role === 'string') {
      return [state.user.role];
    }
    
    if (state.user.role_id) {
      const roleMap = {
        1: 'admin',
        2: 'CEO',
        3: 'HR',
        4: 'Reception'
      };
      return [roleMap[state.user.role_id] || 'user'];
    }
    
    console.log('No roles found, defaulting to basic role');
    return ['user'];
  },
  hasRole: state => roleName => {
    const roles = getters.userRoles(state);
    return roles.includes(roleName);
  },
  hasAnyRole: state => roleNames => {
    const roles = getters.userRoles(state);
    return roles.some(role => roleNames.includes(role));
  }
};

const mutations = {
  setToken(state, token) {
    state.token = token;
  },
  setUser(state, user) {
    state.user = user;
  },
  setUserPermissions(state, permissions) {
    state.userPermissions = permissions;
  },
  setUserRole(state, role) {
    state.userRole = role;
  },
  setError(state, error) {
    state.error = error;
  }
};

const actions = {
  async login({ commit }, credentials) {
    try {
      commit('setError', null);
      const response = await authService.login(credentials);
      
      if (response.data.success) {
        const { token, user } = response.data.data;
        
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        
        const userPermissions = user.permissions || [];
        const userRole = user.role || 'user';
        
        localStorage.setItem('userPermissions', JSON.stringify(userPermissions));
        localStorage.setItem('userRole', userRole);
        
        commit('setToken', token);
        commit('setUser', user);
        commit('setUserPermissions', userPermissions);
        commit('setUserRole', userRole);
        
        router.push('/');
        return true;
      } else {
        commit('setError', response.data.message || 'Login failed');
        return false;
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Login failed';
      commit('setError', errorMessage);
      return false;
    }
  },
  
  logout({ commit }) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('userPermissions');
    localStorage.removeItem('userRole');
    
    commit('setToken', null);
    commit('setUser', null);
    commit('setUserPermissions', []);
    commit('setUserRole', null);
    
    router.push('/login');
  },
  
  checkAuth({  state }) {
    if (state.token) {
      return true;
    }
    return false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}; 